import { css } from '@emotion/core';
import { API } from "aws-amplify";
import axios from 'axios';
import 'containers/common/Detail.css';
import AppendixList from "containers/intropgx/AppendixList";
import Moment from "moment";
import React, { Component } from "react";
import { s3GetURL, s3Upload } from "lib/awsLib";
import {  Button,  Col, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
// First way to import
import { PacmanLoader } from 'react-spinners';
import ReactTable from "react-table";
import 'react-table/react-table.css';






const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class IntroPgXHome extends Component {
    constructor(props) {
        super(props);
        this.updateTableState = this.updateTableState.bind(this);
        this.validateRelatedRecord = this.validateRelatedRecord.bind(this);

        this.file = null;

        this.state = {
            isLoading: null,
            isDeleting: null,
            cityscopeOptions: [],
            selectedCityscope: null,
            cityscope: null,
            cityscopeName: null,
            appendixOptions: [],
            selectedAppendix: null,
            searchByQuarter: false,
            quarterOptions: this.getLastNQuarters(9),
            selectedQuarter: null,
            sales: null,
            classifications: null,
            appendix_totals: null, 
            appendix_class_totals: null,
            classification_mapping: null,
            url: null,
            fileName: null,
            html: null,
            showNo: false
        };
    }

    


  
    async componentDidMount() {
        

        try {
            this.setState({ isLoading: true });   

            const cityscopeOptions = await this.getCityscopes();
            if (cityscopeOptions) {     
                this.setState(state => ({ cityscopeOptions }));
            }
            
            
            document.title = "Cityscope Newsletter Production" ;


            
            this.setState({ isLoading: false });   
        } catch (e) {
            alert(e);
        }
    }

    componentWillUnmount() {
        source.cancel();
    }

    async getCityscopes() {
        return API.get("colin", `/cityscopes/dropdown`, { 'cancelToken': source.token });                
    }

    async getAppendices(filter) {
        
        return API.get("colin", "/appendix", { 'queryStringParameters': filter, 'cancelToken': source.token });
                 
    }

    getLastNQuarters(nQuarters) {
        const quarterFormat = 'Y 0Q';

        let quarters = [];

        for (let i = 0; i < nQuarters; i++) {
            const quarter = Moment().subtract(i, 'Q');
            
            quarters.push({
                value: quarter.format(quarterFormat),
                label: quarter.format(quarterFormat),
                momentObj: quarter
            });
        }

        return quarters;
    }

    async getIntroPgXAll(filter) {
        return API.get("colin", `/intropgx/all`, { 'queryStringParameters': filter,'cancelToken': source.token });                
    }
    async getLedChecks(filter) {
        return API.get("colin", `/proofing/ledchecks`, { 'queryStringParameters': filter,'cancelToken': source.token });                
    }

    handleCityscopeChange = async (selectedCityscope) => {
        // Last cityscope deleted from multi-dropdown
        if (!selectedCityscope || selectedCityscope.length === 0) {
            this.setState(state => ({ selectedCityscope }));
            this.setState(state => ({ cityscope: null, cityscopeName: null }));
            this.setState(state => ({ appendixOptions: [], selectedAppendix: null }));

            return;
        }

        const cityscopeValues = selectedCityscope.map(c => c.value).join(',');
        const cityscopeNames = selectedCityscope.map(c => c.cityscope_name).join(', ');

        this.setState(state => ({ selectedCityscope }));
        this.setState(state => ({ cityscope: cityscopeValues, cityscopeName: cityscopeNames }));

        // Multiple cityscopes under one selected appendix breaks the output table; force quarter search
        if (selectedCityscope.length > 1) {
            this.setState(state => ({ searchByQuarter: true }));

            if (!this.state.selectedQuarter) {
                this.setState(state => ({ selectedQuarter: this.state.quarterOptions[1] })); // Last quarter
            }
        }

        // No need to make the API call if we're searching by quarter (the list is seeded from current date)
        if (this.state.searchByQuarter) {
            return;
        }

        let appendixOptions = await this.getAppendices({cityscope: cityscopeValues});
        if (appendixOptions && appendixOptions.length > 0) {
            // The cityscope prefix to the appendix # is only needed if >1 cityscopes selected
            if (this.state.selectedCityscope.length > 1) {
                appendixOptions.forEach(a => { a.label = `${a.cityscope} ${a.label}`});
                appendixOptions.sort((a, b) => { return a.cityscope.localeCompare(b.cityscope) || b.value - a.value });
            }
            
            this.setState(state => ({ appendixOptions: appendixOptions, selectedAppendix: {label: appendixOptions[0].label, value : appendixOptions[0].value } }));

        }
    
    }

    handleAppendixChange = async (selectedAppendix) => {
        
        this.setState(state => ({ selectedAppendix }));
        this.setState(state => ({ appendix: selectedAppendix.value }));
                    
    }

    handleQuarterChange = async (selectedQuarter) => {

        this.setState({ selectedQuarter: selectedQuarter });

    }

    handleSearchByQuarterChange = event => {
        
        this.handleCheckBoxChange(event);
        this.setState({selectedAppendix: null, selectedQuarter: null});

        if (!this.state.selectedQuarter) {
            this.setState(state => ({ selectedQuarter: this.state.quarterOptions[1] })); // Last quarter
        }

    };

    ///
    handleCheckBoxChange = event => {

        let name = event.target.name
        this.setState({
            [name]: event.target.checked
        })

        

    }

    handleSalesSource= async (e)=>{
        this.setState({ isLoading: true, sales: null });
        const appendix = (!!this.state.selectedAppendix) ? this.state.selectedAppendix.value : null;   
        const quarter = (!!this.state.searchByQuarter) ? this.state.selectedQuarter.value : null;
        const sales = await this.getIntroPgXAll({cityscope: this.state.cityscope, appendix: appendix, quarter: quarter});
        if (sales) {  
            let classifications = [...new Set(sales.map(sale => sale.classification))];  
            for (var i=0; i< classifications.length;i++){
                classifications[i] = {classification: classifications[i]
                                    , make_detail_line: false
                                    , order: 100
                                    , detail_strata: false
                                    , alternate_text: ""
                                    }
            } 
            this.setState(state => ({ sales, classifications }));            
        }        
        this.setState({ isLoading: false });
    }

    handleViewNewsFile= async() =>
    {
        //Sort the classification totals
        let appendix_class_totals = [...this.state.appendix_class_totals];
        for(var x=0;x<appendix_class_totals.length;x++){   
            let classification_pos = this.state.classifications.map(function(e) { return e.classification; }).indexOf(appendix_class_totals[x].classification);
            appendix_class_totals[x].order = this.state.classifications[classification_pos].order;
        }
        appendix_class_totals.sort(function (a, b) { return a.order - b.order });

        const appendixHeader = `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">Three months ended</font></td>\n`+
                               `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">${(this.state.showNo? this.state.appendix_totals[0].appendix+"<br/>":"")+ this.state.appendix_totals[0].issue_date}</font></td>\n`+
                               `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">${(this.state.showNo? this.state.appendix_totals[1].appendix+"<br/>":"")+ this.state.appendix_totals[1].issue_date}</font></td>\n`+
                               `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">${(this.state.showNo? this.state.appendix_totals[2].appendix+"<br/>":"")+ this.state.appendix_totals[2].issue_date}</font></td>\n`+
                               `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">${(this.state.showNo? this.state.appendix_totals[3].appendix+"<br/>":"")+ this.state.appendix_totals[3].issue_date}</font></td>\n`+
                               `<td VALIGN="middle" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER"><b>12 month total</b></font></td>\n`+
                               `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">${(this.state.showNo? this.state.appendix_totals[4].appendix+"<br/>":"")+ this.state.appendix_totals[4].issue_date}</font></td>\n`+
                               `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">${(this.state.showNo? this.state.appendix_totals[5].appendix+"<br/>":"")+ this.state.appendix_totals[5].issue_date}</font></td>\n`+
                               `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">${(this.state.showNo? this.state.appendix_totals[6].appendix+"<br/>":"")+ this.state.appendix_totals[6].issue_date}</font></td>\n`+
                               `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">${(this.state.showNo? this.state.appendix_totals[7].appendix+"<br/>":"")+ this.state.appendix_totals[7].issue_date}</font></td>\n`+
                               `<td VALIGN="middle" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER"><b>12 month total</b></font></td>\n`;

        const selectedQuarter = (this.state.searchByQuarter) ? this.state.selectedQuarter.momentObj : Moment(); // Sensible default
        const quarterHeader = `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">Three months ended</font></td>\n`+
                              `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">${selectedQuarter.clone().subtract(7, 'Q').format('Y 0Q')}</font></td>\n`+
                              `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">${selectedQuarter.clone().subtract(6, 'Q').format('Y 0Q')}</font></td>\n`+
                              `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">${selectedQuarter.clone().subtract(5, 'Q').format('Y 0Q')}</font></td>\n`+
                              `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">${selectedQuarter.clone().subtract(4, 'Q').format('Y 0Q')}</font></td>\n`+
                              `<td VALIGN="middle" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER"><b>12 month total</b></font></td>\n`+
                              `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">${selectedQuarter.clone().subtract(3, 'Q').format('Y 0Q')}</font></td>\n`+
                              `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">${selectedQuarter.clone().subtract(2, 'Q').format('Y 0Q')}</font></td>\n`+
                              `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">${selectedQuarter.clone().subtract(1, 'Q').format('Y 0Q')}</font></td>\n`+
                              `<td VALIGN="BOTTOM" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER">${selectedQuarter.clone().subtract(0, 'Q').format('Y 0Q')}</font></td>\n`+
                              `<td VALIGN="middle" BGCOLOR="#525051"><font FACE="Arial" SIZE="1" COLOR="#FFFFFF"><p ALIGN="CENTER"><b>12 month total</b></font></td>\n`;

        let html = `<table BORDER="0" CELLSPACING="0" WIDTH="850">\n`+
                        `<tr bgcolor="#B90016">\n`+
                        `<td align="left" valign="middle" height="40">&nbsp;<IMG alt="" src="http://www.cityscopeonline.com.au/static/newsletter/CityscopeQuarterlySales.gif"></td>\n`+
                        `<td colspan="10" align="right" valign="middle">&nbsp;<IMG alt="" src="http://www.cityscopeonline.com.au/static/newsletter/RPDataLogo02.gif"> </td></tr>\n`+
                        `<tr bgcolor="#525051"><td colspan="11"><font FACE="Arial" SIZE="2" COLOR="#ffffff"><b>&nbsp;&nbsp;&nbsp;${this.state.cityscopeName} Scorecard</b></td></tr>\n`+
                        `<tr>\n`+

                        ((this.state.searchByQuarter) ? quarterHeader : appendixHeader) +

                        `<tr>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">Total sales ($m)</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${(this.state.appendix_totals[0].saleTotalPrice/1000000).toFixed(1)}</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${(this.state.appendix_totals[1].saleTotalPrice/1000000).toFixed(1)}</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${(this.state.appendix_totals[2].saleTotalPrice/1000000).toFixed(1)}</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${(this.state.appendix_totals[3].saleTotalPrice/1000000).toFixed(1)}</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>${(this.state.appendix_totals.filter(saleTotalPrice => saleTotalPrice.group === 1).map(x=>x.saleTotalPrice).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0)/1000000).toFixed(1)}</b></font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${(this.state.appendix_totals[4].saleTotalPrice/1000000).toFixed(1)}</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${(this.state.appendix_totals[5].saleTotalPrice/1000000).toFixed(1)}</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${(this.state.appendix_totals[6].saleTotalPrice/1000000).toFixed(1)}</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${(this.state.appendix_totals[7].saleTotalPrice/1000000).toFixed(1)}</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>${(this.state.appendix_totals.filter(saleTotalPrice => saleTotalPrice.group === 2).map(x=>x.saleTotalPrice).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0)/1000000).toFixed(1)}</b></font></td>\n`+
                        `</tr>\n`+

                        `<tr>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">Total sales (no.)</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${new Intl.NumberFormat().format(this.state.appendix_totals[0].saleCount)}</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${new Intl.NumberFormat().format(this.state.appendix_totals[1].saleCount)}</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${new Intl.NumberFormat().format(this.state.appendix_totals[2].saleCount)}</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${new Intl.NumberFormat().format(this.state.appendix_totals[3].saleCount)}</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>${new Intl.NumberFormat().format(this.state.appendix_totals.filter(saleCount => saleCount.group === 1).map(x=>x.saleCount).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0))}</b></font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${new Intl.NumberFormat().format(this.state.appendix_totals[4].saleCount)}</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${new Intl.NumberFormat().format(this.state.appendix_totals[5].saleCount)}</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${new Intl.NumberFormat().format(this.state.appendix_totals[6].saleCount)}</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${new Intl.NumberFormat().format(this.state.appendix_totals[7].saleCount)}</font></td>\n`+
                        `<td VALIGN="BOTTOM" BGCOLOR="#FFFFFF"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>${new Intl.NumberFormat().format(this.state.appendix_totals.filter(saleCount => saleCount.group === 2).map(x=>x.saleCount).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0))}</b></font></td>\n`+
                        `</tr>\n`;
            //loop through classifications
            for(var y=0;y<appendix_class_totals.length;y++){
                let class_pos = this.state.classifications.map(function(e) { return e.classification; }).indexOf(appendix_class_totals[y].classification);
                const classification_name = this.state.classifications[class_pos].alternate_text!==""?this.state.classifications[class_pos].alternate_text: this.state.classifications[class_pos].classification;
                
                //Building sales $m
                html = html +`<tr>`                                                            
                for (var p=0;p<this.state.appendix_totals.length;p++){
                    
                    let app_pos =  appendix_class_totals[y].building_sales.map(function(e) { return e.appendix; }).indexOf(this.state.appendix_totals[p].appendix);
                    
                    if(p===0){
                        html = html + `<tr>`+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>${classification_name}</b> building sales ($m)</font></td>\n`
                    }
                    if(p===4 ){
                        const group_1_appendices = this.state.appendix_totals.filter(appendix => appendix.group === 1).map(x=>x.appendix);
                        html = html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>${new Intl.NumberFormat().format((appendix_class_totals[y].building_sales.filter(saleTotalPrice => group_1_appendices.indexOf(saleTotalPrice.appendix)>=0).map(x=>x.saleTotalPrice).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0)/1000000).toFixed(1))}</b></font></td>\n`
                    }
                    
                    if (app_pos===-1){
                        html=html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">-</font></td>\n`
                    }
                    else{
                        html=html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${new Intl.NumberFormat().format((appendix_class_totals[y].building_sales[app_pos].saleTotalPrice/1000000).toFixed(1))}</font></td>\n`
                    }

                }
                let group_2_appendices = this.state.appendix_totals.filter(appendix => appendix.group === 2).map(x=>x.appendix);
                html = html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>${new Intl.NumberFormat().format((appendix_class_totals[y].building_sales.filter(saleTotalPrice => group_2_appendices.indexOf(saleTotalPrice.appendix)>=0).map(x=>x.saleTotalPrice).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0)/1000000).toFixed(1))}</b></font></td>\n`          
                        +`</tr>\n`
                    
                    
                //Building sales no
                html = html +`<tr>`                                                            
                for (var p=0;p<this.state.appendix_totals.length;p++){
                    
                    let app_pos =  appendix_class_totals[y].building_sales.map(function(e) { return e.appendix; }).indexOf(this.state.appendix_totals[p].appendix);
                    
                    if(p===0){
                        html = html + `<tr>`+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${classification_name} building sales (no)</font></td>\n`
                    }
                    if(p===4 ){
                        const group_1_appendices = this.state.appendix_totals.filter(appendix => appendix.group === 1).map(x=>x.appendix);
                        html = html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>${new Intl.NumberFormat().format(appendix_class_totals[y].building_sales.filter(saleCount => group_1_appendices.indexOf(saleCount.appendix)>=0).map(x=>x.saleCount).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0))}</b></font></td>\n`
                    }
                    
                    if (app_pos===-1){
                        html=html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">-</font></td>\n`
                    }
                    else{
                        html=html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${new Intl.NumberFormat().format(appendix_class_totals[y].building_sales[app_pos].saleCount)}</font></td>\n`
                    }

                }
                group_2_appendices = this.state.appendix_totals.filter(appendix => appendix.group === 2).map(x=>x.appendix);
                html = html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>${new Intl.NumberFormat().format(appendix_class_totals[y].building_sales.filter(saleCount => group_2_appendices.indexOf(saleCount.appendix)>=0).map(x=>x.saleCount).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0))}</b></font></td>\n`          
                        +`</tr>\n`
                

                
                //Unit sales $m
                html = html +`<tr>`                                                            
                for (var p=0;p<this.state.appendix_totals.length;p++){
                    
                    let app_pos =  appendix_class_totals[y].unit_sales.map(function(e) { return e.appendix; }).indexOf(this.state.appendix_totals[p].appendix);
                    
                    if(p===0){
                        html = html + `<tr>`+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${classification_name} unit sales ($m)</font></td>\n`
                    }
                    if(p===4 ){
                        const group_1_appendices = this.state.appendix_totals.filter(appendix => appendix.group === 1).map(x=>x.appendix);
                        html = html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>${new Intl.NumberFormat().format((appendix_class_totals[y].unit_sales.filter(saleTotalPrice => group_1_appendices.indexOf(saleTotalPrice.appendix)>=0).map(x=>x.saleTotalPrice).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0)/1000000).toFixed(1))}</b></font></td>\n`
                    }
                    
                    if (app_pos===-1){
                        html=html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">-</font></td>\n`
                    }
                    else{
                        html=html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${new Intl.NumberFormat().format((appendix_class_totals[y].unit_sales[app_pos].saleTotalPrice/1000000).toFixed(1))}</font></td>\n`
                    }

                }
                group_2_appendices = this.state.appendix_totals.filter(appendix => appendix.group === 2).map(x=>x.appendix);
                html = html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>${new Intl.NumberFormat().format((appendix_class_totals[y].unit_sales.filter(saleTotalPrice => group_2_appendices.indexOf(saleTotalPrice.appendix)>=0).map(x=>x.saleTotalPrice).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0)/1000000).toFixed(1))}</b></font></td>\n`          
                        +`</tr>\n`
                    
                    
                //Unit sales no
                html = html +`<tr>`                                                            
                for (var p=0;p<this.state.appendix_totals.length;p++){
                    
                    let app_pos =  appendix_class_totals[y].unit_sales.map(function(e) { return e.appendix; }).indexOf(this.state.appendix_totals[p].appendix);
                    
                    if(p===0){
                        html = html + `<tr>`+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${classification_name} unit sales (no)</font></td>\n`
                    }
                    if(p===4 ){
                        const group_1_appendices = this.state.appendix_totals.filter(appendix => appendix.group === 1).map(x=>x.appendix);
                        html = html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>${new Intl.NumberFormat().format(appendix_class_totals[y].unit_sales.filter(saleCount => group_1_appendices.indexOf(saleCount.appendix)>=0).map(x=>x.saleCount).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0))}</b></font></td>\n`
                    }
                    
                    if (app_pos===-1){
                        html=html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">-</font></td>\n`
                    }
                    else{
                        html=html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${new Intl.NumberFormat().format(appendix_class_totals[y].unit_sales[app_pos].saleCount)}</font></td>\n`
                    }

                }
                group_2_appendices = this.state.appendix_totals.filter(appendix => appendix.group === 2).map(x=>x.appendix);
                html = html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>${new Intl.NumberFormat().format(appendix_class_totals[y].unit_sales.filter(saleCount => group_2_appendices.indexOf(saleCount.appendix)>=0).map(x=>x.saleCount).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0))}</b></font></td>\n`          
                        +`</tr>\n`
                    
                //Strata sales totals
                if (this.state.classifications[class_pos].detail_strata=== true){
                   
                    //Unit sales count avg
                    html = html+`<tr>`
                    for (var p=0;p<this.state.appendix_totals.length;p++){

                        let app_pos =  appendix_class_totals[y].strata_sales.map(function(e) { return e.appendix; }).indexOf(this.state.appendix_totals[p].appendix);
                    
                        if(p===0){
                            html = html + `<tr>`+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${classification_name} unit sales avg (no)*</font></td>\n`
                        }
                        if(p===4 ){
                            const group_1_appendices = this.state.appendix_totals.filter(appendix => appendix.group === 1).map(x=>x.appendix);
                            html = html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>${new Intl.NumberFormat().format((appendix_class_totals[y].strata_sales.filter(saleCount => group_1_appendices.indexOf(saleCount.appendix)>=0).map(x=>x.strataSaleCount).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0)))}</b></font></td>\n`
                        }
                        
                        if (app_pos===-1){
                            html=html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">-</font></td>\n`
                        }
                        else{
                            html=html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">${new Intl.NumberFormat().format((appendix_class_totals[y].strata_sales[app_pos].strataSaleCount))}</font></td>\n`
                        }


                        }
                    group_2_appendices = this.state.appendix_totals.filter(appendix => appendix.group === 2).map(x=>x.appendix);
                    html = html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>${new Intl.NumberFormat().format((appendix_class_totals[y].strata_sales.filter(saleCount => group_2_appendices.indexOf(saleCount.appendix)>=0).map(x=>x.strataSaleCount).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0)))}</b></font></td>\n`          
                            +`</tr>\n`


                   
                    //Method 1
                    html = html+`<tr>`
                    for (var p=0;p<this.state.appendix_totals.length;p++){

                        let app_pos =  appendix_class_totals[y].strata_sales.map(function(e) { return e.appendix; }).indexOf(this.state.appendix_totals[p].appendix);
                    
                        if(p===0){
                            html = html + `<tr>`+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">Average price per sqm: method 1 (total sqm basis)**</font></td>\n`
                        }
                        if(p===4 ){
                            const group_1_appendices = this.state.appendix_totals.filter(appendix => appendix.group === 1).map(x=>x.appendix);
                            html = html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>$${new Intl.NumberFormat().format(((appendix_class_totals[y].strata_sales.filter(saleCount => group_1_appendices.indexOf(saleCount.appendix)>=0).map(x=>x.strataSalePrice).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0))/ (appendix_class_totals[y].strata_sales.filter(saleCount => group_1_appendices.indexOf(saleCount.appendix)>=0).map(x=>x.strataUnitArea).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0))).toFixed(0))}</b></font></td>\n`
                        }
                        
                        if (app_pos===-1){
                            html=html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">-</font></td>\n`
                        }
                        else{
                            html=html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">$${new Intl.NumberFormat().format((appendix_class_totals[y].strata_sales[app_pos].strataSalePrice/appendix_class_totals[y].strata_sales[app_pos].strataUnitArea).toFixed(0))}</font></td>\n`
                        }


                        }
                    group_2_appendices = this.state.appendix_totals.filter(appendix => appendix.group === 2).map(x=>x.appendix);
                    html = html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>$${new Intl.NumberFormat().format(((appendix_class_totals[y].strata_sales.filter(saleCount => group_2_appendices.indexOf(saleCount.appendix)>=0).map(x=>x.strataSalePrice).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0))/ (appendix_class_totals[y].strata_sales.filter(saleCount => group_2_appendices.indexOf(saleCount.appendix)>=0).map(x=>x.strataUnitArea).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0))).toFixed(0))}</b></font></td>\n`
                            +`</tr>\n`

                    //Method 2
                    html = html+`<tr>`;
                    let perSqmWeightedTotal= 0;
                    
                    for (var p=0;p<this.state.appendix_totals.length;p++){

                        let app_pos =  appendix_class_totals[y].strata_sales.map(function(e) { return e.appendix; }).indexOf(this.state.appendix_totals[p].appendix);
                        

                        if(p===0){
                            html = html + `<tr>`+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">Average price per sqm: method 2 (units basis)***</font></td>\n`
                        }
                        if(p===4 ){
                            const group_1_appendices = this.state.appendix_totals.filter(appendix => appendix.group === 1).map(x=>x.appendix);
                            console.log(perSqmWeightedTotal);
                            
                            html = html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>$${new Intl.NumberFormat().format((perSqmWeightedTotal/ (appendix_class_totals[y].strata_sales.filter(saleCount => group_1_appendices.indexOf(saleCount.appendix)>=0).map(x=>x.strataSaleCount).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0))).toFixed(0))} </b></font></td>\n`
                            perSqmWeightedTotal =0;
                        }
                        
                        if (app_pos>=0 ){
                            if(appendix_class_totals[y].strata_sales[app_pos].strataPricePerSqm){
                                perSqmWeightedTotal  = perSqmWeightedTotal +  (appendix_class_totals[y].strata_sales[app_pos].strataPricePerSqm * appendix_class_totals[y].strata_sales[app_pos].strataSaleCount) ; 
                                
                            }
                        }

                        if (app_pos===-1){
                            html=html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">-</font></td>\n`
                        }
                        else{
                            html=html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER">$${new Intl.NumberFormat().format((appendix_class_totals[y].strata_sales[app_pos].strataPricePerSqm).toFixed(0))}</font></td>\n`
                        }


                        }
                    group_2_appendices = this.state.appendix_totals.filter(appendix => appendix.group === 2).map(x=>x.appendix);
                    html = html+`<td VALIGN="BOTTOM" BGCOLOR="${y%2===0?"#EAEAEA":"#FFFFFF"}"><font FACE="Arial" SIZE="1" COLOR="#000000"><p ALIGN="CENTER"><b>$${new Intl.NumberFormat().format((perSqmWeightedTotal/ (appendix_class_totals[y].strata_sales.filter(saleCount => group_2_appendices.indexOf(saleCount.appendix)>=0).map(x=>x.strataSaleCount).reduce( ( accumulator, currentValue ) => accumulator + currentValue,0))).toFixed(0))}</b></font></td>\n`
                            +`</tr>\n`
                   
                  

                    
                }
            
        }

        
        html = html +`<tr><td colspan=11><br><p align="center"><font SIZE="1">*Unit sales used in averages exclude Off the Plan, Related Party, Part Interest, Extraordinary and Multiple Property sales.&nbsp;<br>**Method 1 is calculated by taking the total price of all units sold and dividing that figure by the total square metres of all units.&nbsp;<br>***Method 2 is calculated by taking the price per square metre of each unit, and averaging the price.&nbsp;<br>"Other" sales include properties classified - ${Object.keys(this.state.classification_mapping).filter(key => this.state.classification_mapping[key]==="Other").join("; ")}.</font></p></td></tr>\n`;
        html = html+`</table><br/>\n`;
        html = html.replace(/\$NaN/g, '-');

        var today = new Date();
        var dd = today.getDate();
        
        var mm = today.getMonth()+1; 
        var yyyy = today.getFullYear();
        const fileName = this.state.cityscope+"_intropgx_"+yyyy+mm+dd+".html";
        this.file = new File([new Blob([html], { type: 'text/html', endings: 'native' })],fileName);
        const folder = "article/intropgx";
        const attachment = this.file
            ? await s3Upload(this.file, folder)
            : null;
            console.log("Attachment name-"+attachment);
            const url = await s3GetURL(attachment.replace('article/intropgx/',""),'article/intropgx');
            this.setState({url,fileName,html});
        
            
    }

    handleConsolidate = async() =>
    {
        const months = ["Jan", "Feb", "Mar","Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        let classification_mapping = {};
        //Update classification to 'Other' where no detail line selected
        for (var i =0; i < this.state.classifications.length; i++)
        {
            
            if (this.state.classifications[i].make_detail_line){
                classification_mapping[this.state.classifications[i].classification] = this.state.classifications[i].classification;
            }
            else{
                classification_mapping[this.state.classifications[i].classification] = "Other";
            }
        }
        console.log(classification_mapping);
        

        let original_classifications = [...this.state.classifications];
        let classifications = original_classifications.filter(classification=> classification_mapping[classification.classification]!=="Other");

        //Add 'Other record
        classifications.push(
                            {classification: 'Other'
                                , make_detail_line: false
                                , order: 100
                                , detail_strata: false
                                , alternate_text: ""
                                }
                            );
        this.setState({classifications});

        let appendix_totals = [];
        let appendix_class_totals=[];         

        //Update sales to the new classification on the sales records
        let sales = [...this.state.sales];
        for (var i=0; i < sales.length; i++)
        {
            const classification = classification_mapping[sales[i].classification];
            const appendix = sales[i].appendix;
            //update sale record
            sales[i].classification = classification;
            let appendix_pos = appendix_totals.map(function(e) { return e.appendix; }).indexOf(sales[i].appendix);
            
            if (this.state.searchByQuarter === true) {
                appendix_pos = appendix_totals.map(function(e) { return e.quarter_date; }).indexOf(sales[i].quarter_date);
            }

            //add to appendix totals
            if (appendix_pos>=0){
                ++ appendix_totals[appendix_pos].saleCount;
                appendix_totals[appendix_pos].saleTotalPrice = appendix_totals[appendix_pos].saleTotalPrice + Number(sales[i].sale_price.replace(/[^0-9.-]+/g,""));                    
            }
            else{
                let appendix_total={
                                appendix: sales[i].appendix,
                                saleCount: 1,
                                saleTotalPrice: Number(sales[i].sale_price.replace(/[^0-9.-]+/g,"")),
                                group: 0,
                                issue_date: months[new Date(sales[i].issue_date).getMonth()] + "-" + new Date(sales[i].issue_date).getFullYear().toString().substring(2,4),
                                quarter_date: sales[i].quarter_date 
                                };

                appendix_totals.push(appendix_total);

             
            }

            appendix_totals.sort(function (a, b) { return a.appendix - b.appendix });

            for(var x=0;x<appendix_totals.length;x++){

                appendix_totals[x].group =( x+1)/4.00<=1.00? 1:2;
            }

            //add to appendix class totals
            let key =  sales[i].classification ;
            let key_pos = appendix_class_totals.map(function(e) { return e.key; }).indexOf(key);

            
            if (key_pos>=0){

                let appendix_pos=-1;
                if (sales[i].is_unit==="Strata"){
                    appendix_pos = appendix_class_totals[key_pos].unit_sales.map(function(e) { return e.appendix; }).indexOf(sales[i].appendix);
                    if(appendix_pos>=0){
                        ++ appendix_class_totals[key_pos].unit_sales[appendix_pos].saleCount;
                        appendix_class_totals[key_pos].unit_sales[appendix_pos].saleTotalPrice = appendix_class_totals[key_pos].unit_sales[appendix_pos].saleTotalPrice + Number(sales[i].sale_price.replace(/[^0-9.-]+/g,""));   
                    }
                    else{
                        let sale = {};
                        sale.appendix = sales[i].appendix;                                            
                        sale.saleCount=1;
                        sale.saleTotalPrice = Number(sales[i].sale_price.replace(/[^0-9.-]+/g,"")); 
                        sale.group = 0;
                        sale.issue_date = months[new Date(sales[i].issue_date).getMonth()] + "-" + new Date(sales[i].issue_date).getFullYear().toString().substring(2,4);
                        appendix_class_totals[key_pos].unit_sales.push(sale);
                    }

                    //strata sales totals
                    if (sales[i].is_unit === "Strata" && sales[i].unit_area  && sales[i].off_the_plan === false && sales[i].related_parties === false && sales[i].extraordinary === false && sales[i].part_interest === false  && sales[i].multi_sale === false)
                    {
                        appendix_pos = appendix_class_totals[key_pos].strata_sales.map(function(e) { return e.appendix; }).indexOf(sales[i].appendix);
                        if(appendix_pos>=0){
                            ++ appendix_class_totals[key_pos].strata_sales[appendix_pos].strataSaleCount;                         
                            appendix_class_totals[key_pos].strata_sales[appendix_pos].strataPricePerSqm = ((appendix_class_totals[key_pos].strata_sales[appendix_pos].strataPricePerSqm * (appendix_class_totals[key_pos].strata_sales[appendix_pos].strataSaleCount-1))+ Number(sales[i].sale_price.replace(/[^0-9.-]+/g,"")) / sales[i].unit_area) / appendix_class_totals[key_pos].strata_sales[appendix_pos].strataSaleCount; 
                            appendix_class_totals[key_pos].strata_sales[appendix_pos].strataSalePrice = appendix_class_totals[key_pos].strata_sales[appendix_pos].strataSalePrice + Number(sales[i].sale_price.replace(/[^0-9.-]+/g,"")); 
                            appendix_class_totals[key_pos].strata_sales[appendix_pos].strataUnitArea = appendix_class_totals[key_pos].strata_sales[appendix_pos].strataUnitArea + sales[i].unit_area; 
                        }
                        else{
                            let strata_sale = {}
                            strata_sale.appendix = sales[i].appendix;    
                            strata_sale.strataPricePerSqm = Number(sales[i].sale_price.replace(/[^0-9.-]+/g,"")) / sales[i].unit_area; 
                            strata_sale.strataSaleCount = 1; 
                            strata_sale.strataSalePrice = Number(sales[i].sale_price.replace(/[^0-9.-]+/g,"")); 
                            strata_sale.strataUnitArea = sales[i].unit_area; 
                            appendix_class_totals[key_pos].strata_sales.push(strata_sale);
                        }
                    }


                }
                else{
                    appendix_pos = appendix_class_totals[key_pos].building_sales.map(function(e) { return e.appendix; }).indexOf(sales[i].appendix);
                    if(appendix_pos>=0){
                        ++ appendix_class_totals[key_pos].building_sales[appendix_pos].saleCount;
                        appendix_class_totals[key_pos].building_sales[appendix_pos].saleTotalPrice = appendix_class_totals[key_pos].building_sales[appendix_pos].saleTotalPrice + Number(sales[i].sale_price.replace(/[^0-9.-]+/g,""));   
                    }
                    else{
                        let sale = {};
                        sale.appendix = sales[i].appendix;                                            
                        sale.saleCount=1;
                        sale.saleTotalPrice = Number(sales[i].sale_price.replace(/[^0-9.-]+/g,"")); 
                        sale.group = 0;
                        sale.issue_date = months[new Date(sales[i].issue_date).getMonth()] + "-" + new Date(sales[i].issue_date).getFullYear().toString().substring(2,4);
                        appendix_class_totals[key_pos].building_sales.push(sale);
                    }
                }

                
                
            }
            else{
                
                let appendix_class_total={};
                appendix_class_total.key=key;
                appendix_class_total.classification = sales[i].classification;
                appendix_class_total.unit_sales=[];
                appendix_class_total.strata_sales=[];
                appendix_class_total.building_sales=[];

                let sale = {};
                sale.appendix = sales[i].appendix;                                            
                sale.saleCount=1;
                sale.saleTotalPrice = Number(sales[i].sale_price.replace(/[^0-9.-]+/g,"")); 
                sale.group = 0;
                sale.issue_date = months[new Date(sales[i].issue_date).getMonth()] + "-" + new Date(sales[i].issue_date).getFullYear().toString().substring(2,4);
                

                if (sales[i].is_unit==="Strata"){
                    appendix_class_total.unit_sales.push(sale);
                    //Strata sales totals
                    if (sales[i].is_unit === "Strata" && sales[i].unit_area  && sales[i].off_the_plan === false && sales[i].related_parties === false && sales[i].extraordinary === false && sales[i].part_interest === false  && sales[i].multi_sale === false)
                    {
                        let strata_sale = {}
                        strata_sale.appendix = sales[i].appendix;    
                        strata_sale.strataPricePerSqm = Number(sales[i].sale_price.replace(/[^0-9.-]+/g,"")) / sales[i].unit_area; 
                        strata_sale.strataSaleCount = 1; 
                        strata_sale.strataSalePrice = Number(sales[i].sale_price.replace(/[^0-9.-]+/g,"")); 
                        strata_sale.strataUnitArea = sales[i].unit_area; 
                        appendix_class_total.strata_sales.push(strata_sale);
                    }
                }
                else{
                    appendix_class_total.building_sales.push(sale);                   
                }

               
                
                appendix_class_totals.push(appendix_class_total);
            }
            appendix_class_totals.sort(function (a, b) { return a.classification - b.classification });


           
            
        }

        // The code that handles [View News File] expects 8 elements in `appendix_totals` so,
        // if we have less than that, insert remaining dummy elements.
        // Otherwise it all blows up and we get no output.
        if (appendix_totals.length < 8) {
            for (const _ of Array(8 - appendix_totals.length).keys()) {
                appendix_totals.push({
                    appendix: null,
                    saleCount: 0,
                    saleTotalPrice: 0,
                    group: 2,
                    issue_date: null,
                    quarter_date: null,
                });
            }
        }

        this.setState({sales, appendix_totals, appendix_class_totals, classification_mapping});
        

    }

    validateRelatedRecord(record, set) {
    
        return [true,];
    }
   
    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false });
        let classifications = [...this.state.classifications];
        for (var i=0; i<classifications.length; i++){
            const validation = this.validateRelatedRecord(classifications[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                // if (classifications[i].hasOwnProperty("modified")) {
                //     if (classifications[i].modified === true) {
                //         console.log(i);
                //         //Save the data
                //         if (!this.state.savingNewRecord) {
                //             if (classifications[i].hasOwnProperty("new_record")) {
                //                 if (classifications[i].new_record === true) {
                //                     this.setState({ savingNewRecord: true });
                //                 }
                //             }
                //             const result = await this.handleDataSave(classifications[i]);
                //             if (result.result) {
                //                 classifications[i].modified = false;
                //                 if (classifications[i].hasOwnProperty("new_record")) {
                //                     if (classifications[i].new_record === true) {

                //                         classifications[i][this.state.dataSetPrimaryKey] = result.id;
                //                         this.setState({ savingNewRecord: false });
                //                     }
                //                     classifications[i].new_record = false;
                //                 }
                                                               
                //             }
                //             else {
                //                 this.setState({ errorMessage: result.error_message });
                //                 this.setState({ showAlert: true });
                //             }
                //         }
                //     }

                // }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }   
        
        classifications.sort(function (a, b) { return a.order - b.order });
        
        this.setState({classifications});

    }

    updateTableState(data, set) {
        
        this.setState({
            [set]: data
        });
    }
    
    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let classifications = [...this.state.classifications];
        classifications[cellInfo.index][cellInfo.column.id] = event.target.value;
        classifications[cellInfo.index].modified = true;
        this.setState({classifications});
    };
    handleNumberChange = (cellInfo, event) => {
        let classifications = [...this.state.classifications];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        classifications[cellInfo.index][cellInfo.column.id] = Number(val);
        classifications[cellInfo.index].modified = true;
        this.setState({classifications});
    };
    handleFrontageChange = (cellInfo, event) => {
        let classifications = [...this.state.classifications];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        val = Math.round(parseFloat(val) * 100) / 100; //Round to 2 decimal places
        classifications[cellInfo.index][cellInfo.column.id] = Number(val);
        classifications[cellInfo.index].modified = true;
        this.setState({classifications});
    };
    handleCheckboxChange = (cellInfo, event) => {
        let classifications = [...this.state.classifications];
        classifications[cellInfo.index][cellInfo.column.id] = event.target.checked;
        classifications[cellInfo.index].modified = true;
        this.setState({classifications});
    };

    handleDateChange = (cellInfo, event) => {
        let classifications = [...this.state.classifications];
        classifications[cellInfo.index][cellInfo.column.id] = new Date(event);
        classifications[cellInfo.index].modified = true;
        this.setState({classifications});

    }

    
   
    renderEditable = cellInfo => {
        const cellValue = this.state.classifications[cellInfo.index][cellInfo.column.id];
       
        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }

    render() {
        return (
            <div className="IntroPgx">
                    {this.state.isLoading &&
                    <div className="outer-div"><div className='sweet-loading inner-div' >
                        <PacmanLoader
                            css={css`
                            display: block;
                            margin: 0 auto;
                            border-color: red`}
                            sizeUnit={"px"}
                            size={20}
                            color={'#e03c31'}
                            loading={this.state.isLoading}
                        />
                    </div> 
                        </div>}
               
                {this.state.cityscopeOptions && this.props.isAuthenticated && !this.state.isLoading &&
                    <div className="IntroPgXForm">
                    <Row >
                        <Col sm={12} md={12} lg={12}>
                            <h6>
                                Cityscope Newsletter Production
                                </h6>
                    
                        </Col>
                    </Row>
                    <Form  >                  
                        <Row className="justify-content-md-center">
                            <Col sm={7} md={6} lg={7}>
                                <Form.Group controlId="cityscope" >
                                        
                                    <Form.Check checked={this.state.searchByQuarter}
                                        onChange={this.handleSearchByQuarterChange}
                                        label="Search by quarter"
                                        disabled={this.state.selectedCityscope && this.state.selectedCityscope.length > 1}
                                        type="checkbox"
                                        name="searchByQuarter"
                                    />

                                </Form.Group>
                            </Col>    
                        </Row>
                        <Row className="justify-content-md-center">
                            <Col sm={2} md={2} lg={2}>
                                <Form.Group controlId="cityscope" >
                                    
                                    
                                        <Select
                                            value={this.state.selectedCityscope}
                                            onChange={this.handleCityscopeChange}
                                            options={this.state.cityscopeOptions}
                                            placeholder="Cityscope"
                                            isMulti
                                        />
                                   

                                </Form.Group>
                            </Col>

                            { !this.state.searchByQuarter &&
                            <Col sm={2} md={2} lg={1}>
                                <Form.Group controlId="appendix" >
                                    
                                    
                                        <Select
                                            value={this.state.selectedAppendix}
                                            onChange={this.handleAppendixChange}
                                            options={this.state.appendixOptions}
                                            placeholder="Appendix"
                                        />
                                   

                                </Form.Group>
                            </Col>
                            }

                            { this.state.searchByQuarter &&
                            <Col sm={2} md={2} lg={1}>
                                <Form.Group controlId="quarter" >
                                    
                                    
                                        <Select
                                            value={this.state.selectedQuarter}
                                            onChange={this.handleQuarterChange}
                                            options={this.state.quarterOptions}
                                            placeholder="Quarter"
                                        />
                                   

                                </Form.Group>
                            </Col>
                            }

                            <Col sm={2} md={2} lg={2}>
                                <Button  variant="primary" block onClick={this.handleSalesSource}>Get Sales Source</Button><br />
                            </Col>
                        
                            <Col sm={2} md={2} lg={2}>
                                <Button variant="primary" block  onClick={this.handleConsolidate}>Consolidate "Other"</Button><br />
                            </Col> 
                        
                           
                        </Row>
                        
                    </Form>
                    </div>
                    }
                    
                    { this.state.classifications &&
                    <div className="IntroPgXResults">
                        <Row>
                            <Col sm={3} md={3} lg={3}></Col>
                            <Col>
                            <ReactTable
                                data={this.state.classifications}
                                columns={ [{
                                                id: 'classification',
                                                Header: 'Classification',
                                                accessor: 'classification',                                          
                                                style: { 'whiteSpace': 'unset' } 
                                            }
                                            ,{
                                                id: 'make_detail_line',
                                                Header: 'Own Detail Line',
                                                accessor: 'make_detail_line',                                          
                                                style: { textAlign: "center" },
                                                Cell: this.renderEditable
                                            }
                                            ,{
                                                id: 'order',
                                                Header: 'Order',
                                                accessor: 'order',                                          
                                                style: { textAlign: "center" },
                                                Cell: this.renderEditable
                                            }
                                            ,{
                                                id: 'detail_strata',
                                                Header: 'Detail Strata?',
                                                accessor: 'detail_strata',                                          
                                                style: { textAlign: "center" },
                                                Cell: this.renderEditable
                                            }
                                            ,{
                                                id: 'alternate_text',
                                                Header: 'Alternate Text?',
                                                accessor: 'alternate_text',                                          
                                                style: { 'whiteSpace': 'unset' } ,
                                                Cell: this.renderEditable
                                            }

                                            ]}
                                defaultPageSize={10}
                                sortable={true}
                            />
                            </Col>
                            <Col sm={3} md={3} lg={3}></Col>
                        </Row>
                        {this.state.appendix_totals &&
                        <div>
                            <br/><br/>
                          <br/><br/>
                          {!this.state.searchByQuarter &&
                          <Row className="justify-content-md-center">
                              <Col sm={5} md={5} lg={5}></Col>
                              <Col>
                              <Form.Group controlId="showNo">

                                    <Form.Check checked={this.state.showNo}
                                        onChange={this.handleCheckBoxChange}
                                        label="Include Appendix # Header"
                                        type="checkbox"
                                        name="showNo"                                                                                
                                    />

                                </Form.Group>
                                </Col>
                              </Row> 
                            }
                        <Row className="justify-content-md-center">
                            <Col sm={2} md={2} lg={2}>
                                
                            </Col>

                        
                            <Col sm={2} md={2} lg={2}>
                                <Button  variant="primary" block onClick={this.handleViewNewsFile}>View News File</Button><br />
                            </Col>
                        
                            <Col sm={2} md={2} lg={2}>
                                
                            </Col> 
                        
                           
                        </Row>
                        {this.state.url &&
                        <div>
                         <Row className="justify-content-lg-center">
                         <Col sm={5} md={5} lg={5}></Col>
                             <Col><h5>
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                href={this.state.url}
                                >
                                    {this.state.fileName }
                                </a></h5>
                
                            </Col>
                            </Row>
                            <Row  className="justify-content-lg-center">
                                <Col sm={4} md={4} lg={4}></Col>
                                <Col>
                                    {this.state.html &&
                                    
                                    <div dangerouslySetInnerHTML={{ __html:this.state.html}} />
                                    }
                                </Col>

                            </Row>
                            </div>


                                }
                        </div>
                        }
                    </div> //IntroPgXResults
                    }

                

            </div>

                
                
        );
        
    }
}